import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { Brasao } from "../../components/Layout";
import { api, fmt } from "../../lib/api";

export function EsqueciSenha() {
  const [cpf, setCpf] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [feito, setFeito] = useState(false);

  async function enviar(ev: FormEvent) {
    ev.preventDefault();
    setEnviando(true);
    try {
      await api.post("/api/publico/candidatos/esqueci-senha", { cpf: cpf.replace(/\D/g, "") });
    } finally {
      // Mesma resposta exista ou não o CPF: não confirma quais CPFs têm conta.
      setFeito(true);
      setEnviando(false);
    }
  }

  return (
    <div className="tema-candidato tc-entrada">
      <div className="tc-entrada-corpo">
        <div className="tc-entrada-caixa">
          <div className="linha" style={{ justifyContent: "center", marginBottom: 8 }}>
            <Brasao tamanho={32} />
          </div>

          {feito ? (
            <div className="tc-cartao">
              <h1 className="tc-titulo">Confira seu e-mail</h1>
              <p className="tc-ajuda">
                Se houver uma conta com esse CPF, enviamos um link de redefinição de senha
                para o e-mail cadastrado. O link vale por 2 horas.
              </p>
            </div>
          ) : (
            <form onSubmit={enviar} className="tc-cartao" noValidate>
              <h1 className="tc-titulo">Esqueci minha senha</h1>
              <p className="tc-ajuda">Informe o CPF da sua conta. Enviaremos um link por e-mail.</p>

              <div className="tc-campo">
                <label htmlFor="cpf">CPF</label>
                <input id="cpf" value={cpf} inputMode="numeric" required
                       onChange={(e) => setCpf(fmt.cpf(e.target.value))} />
              </div>

              <button type="submit" className="tc-btn tc-btn-primario tc-btn-largo" disabled={enviando}>
                {enviando ? "Enviando..." : "Enviar link de redefinição"}
              </button>
            </form>
          )}

          <div className="tc-links">
            <Link to="/entrar">Voltar para o login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
